import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BlockchainExplorer from './BlockchainExplorer';
import BlocksPage from './components/BlocksPage';
import ValidatorsPage from './components/ValidatorsPage';
import ValidatorDetailsPage from './components/ValidatorDetailsPage';
import SearchResultPage from './components/SearchResultPage';
import AddressDetailsPage from './components/AddressDetailsPage';
import TokensPage from './components/TokensPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BlockchainExplorer />} />
        <Route path="/blocks" element={<BlocksPage />} />
        <Route path="/validators" element={<ValidatorsPage />} />
        <Route path="/validator/:address" element={<ValidatorDetailsPage />} />
        <Route path="/search/:query" element={<SearchResultPage />} />
        <Route path="/tx/:txHash" element={<SearchResultPage />} />
        <Route path="/address/:address" element={<AddressDetailsPage />} /> {/* Add this line */}
        <Route path="/tokens" element={<TokensPage />} />
      </Routes>
    </Router>
  );
}

export default App;